import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import HelpIcon from '../../../../../assets/icons/help.svg';

export const getData = (
  _event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {actor, user_questionnaire} = contexts;

  return {
    avatar: actor?.avatar,
    avatarPlaceholder: actor?.name,

    icon: HelpIcon,
    iconGradient: 'success',
    title: i18n.t('notifications:questionnaire_completed.title', {
      actorName: actor?.name,
      questionnaireTitle: user_questionnaire?.title,
    }),
  };
};
